export const breakpoints: { [key: string]: number } = {
  xs: 480,
  sm: 768,
  md: 1024,
  lg: 1140,
}

export const breakpointMinQuery = (name: string): string => {
  const breakpoint = `${breakpoints[name]}px`

  return `@media (min-width: ${breakpoint})`
}

export const breakpointMaxQuery = (name: string): string => {
  const breakpoint = `${breakpoints[name]}px`

  return `@media (max-width: ${breakpoint})`
}
